
import { useState } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import BookingModal from '../home/components/BookingModal';

export default function DatenschutzPage() {
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);

  const openBookingModal = () => setIsBookingModalOpen(true);
  const closeBookingModal = () => setIsBookingModalOpen(false);

  return (
    <div className="min-h-screen bg-white">
      <Header onBookingClick={openBookingModal} />
      
      {/* Hero Section */}
      <section className="pt-32 pb-12 lg:pt-40 lg:pb-16 px-6 lg:px-12 bg-white">
        <div className="max-w-4xl mx-auto">
          <p className="text-sm text-[#042A60]/60 mb-4">
            01 / Datenschutz
          </p>
          <h1 className="text-4xl lg:text-6xl text-[#042A60] mb-6 font-light">
            Datenschutzerklärung
          </h1>
          <p className="text-base text-[#042A60]/80 leading-relaxed">
            Wir nehmen Ihre Datenschutzrechte ernst. In dieser Erklärung informieren wir Sie darüber, wie wir personenbezogene Daten erheben, verarbeiten und schützen.
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-12 lg:py-16 px-6 lg:px-12 bg-white">
        <div className="max-w-4xl mx-auto space-y-12">
          
          {/* Automatische Datenspeicherung */}
          <div>
            <h2 className="text-2xl lg:text-3xl text-[#042A60] mb-6 font-light">
              Automatische Datenspeicherung
            </h2>
            <p className="text-base text-[#042A60]/80 leading-relaxed mb-4">
              Wenn Sie heutzutage Websites besuchen, werden gewisse Informationen automatisch erstellt und gespeichert, so auch auf dieser Website. Diese gesammelten Daten sollten möglichst sparsam und nur mit Begründung gesammelt werden.
            </p>
            <p className="text-base text-[#042A60]/80 leading-relaxed mb-4">
              Wenn Sie unsere Website besuchen, speichert unser Webserver automatisch folgende Daten:
            </p>
            <ul className="list-disc list-inside text-base text-[#042A60]/80 leading-relaxed space-y-2 ml-4">
              <li>die Adresse (URL) der aufgerufenen Webseite</li>
              <li>Browser und Browserversion</li>
              <li>das verwendete Betriebssystem</li>
              <li>die Adresse (URL) der zuvor besuchten Seite (Referrer URL)</li>
              <li>den Hostname und die IP-Adresse des Geräts</li>
              <li>Datum und Uhrzeit</li>
            </ul>
            <p className="text-base text-[#042A60]/80 leading-relaxed mt-4">
              In der Regel werden diese Daten zwei Wochen gespeichert und danach automatisch gelöscht. Wir geben diese Daten nicht weiter, können jedoch nicht ausschließen, dass diese Daten beim Vorliegen von rechtswidrigem Verhalten von Behörden eingesehen werden.
            </p>
          </div>

          {/* Cookies */}
          <div>
            <h2 className="text-2xl lg:text-3xl text-[#042A60] mb-6 font-light">
              Cookies
            </h2>
            <h3 className="text-lg font-medium text-[#042A60] mb-3">
              Was sind Cookies?
            </h3>
            <p className="text-base text-[#042A60]/80 leading-relaxed mb-4">
              Unsere Website verwendet HTTP-Cookies um nutzerspezifische Daten zu speichern. Im Folgenden erklären wir, was Cookies sind und warum Sie genutzt werden, damit Sie die folgende Datenschutzerklärung besser verstehen.
            </p>
            <p className="text-base text-[#042A60]/80 leading-relaxed mb-4">
              Immer wenn Sie durch das Internet surfen, verwenden Sie einen Browser. Bekannte Browser sind beispielsweise Chrome, Safari, Firefox, Internet Explorer und Microsoft Edge. Die meisten Webseiten speichern kleine Text-Dateien in Ihrem Browser. Diese Dateien nennt man Cookies.
            </p>
            <p className="text-base text-[#042A60]/80 leading-relaxed mb-4">
              Eines ist nicht von der Hand zu weisen: Cookies sind echt nützliche Helferlein. Fast alle Webseiten verwenden Cookies. Genauer gesprochen sind es HTTP-Cookies, da es auch noch andere Cookies für andere Anwendungsbereiche gibt. HTTP-Cookies sind kleine Dateien, die von unserer Website auf Ihrem Computer gespeichert werden. Diese Cookie-Dateien werden automatisch im Cookie-Ordner, quasi dem „Hirn" Ihres Browsers, untergebracht.
            </p>

            <h3 className="text-lg font-medium text-[#042A60] mb-3 mt-6">
              Welche Arten von Cookies gibt es?
            </h3>
            <p className="text-base text-[#042A60]/80 leading-relaxed mb-4">
              Die Frage welche Cookies wir im Speziellen verwenden, hängt von den verwendeten Diensten ab und wird in den folgenden Abschnitten der Datenschutzerklärung geklärt. An dieser Stelle möchten wir kurz auf die verschiedenen Arten von HTTP-Cookies eingehen.
            </p>
            <p className="text-base text-[#042A60]/80 leading-relaxed mb-2">
              Man kann 4 Arten von Cookies unterscheiden:
            </p>
            <ul className="list-disc list-inside text-base text-[#042A60]/80 leading-relaxed space-y-2 ml-4 mb-4">
              <li><strong>Unerlässliche Cookies:</strong> Diese Cookies sind nötig, um grundlegende Funktionen der Website sicherzustellen.</li>
              <li><strong>Zweckmäßige Cookies:</strong> Diese Cookies sammeln Infos über das Userverhalten und ob der User etwaige Fehlermeldungen bekommt.</li>
              <li><strong>Zielorientierte Cookies:</strong> Diese Cookies sorgen für eine bessere Nutzerfreundlichkeit.</li>
              <li><strong>Werbe-Cookies:</strong> Diese Cookies werden auch Targeting-Cookies genannt. Sie dienen dazu dem User individuell angepasste Werbung zu liefern.</li>
            </ul>

            <h3 className="text-lg font-medium text-[#042A60] mb-3 mt-6">
              Wie kann ich Cookies löschen?
            </h3>
            <p className="text-base text-[#042A60]/80 leading-relaxed mb-4">
              Wie und ob Sie Cookies verwenden wollen, entscheiden Sie selbst. Unabhängig von welchem Service oder welcher Website die Cookies stammen, haben Sie immer die Möglichkeit Cookies zu löschen, zu deaktivieren oder nur teilweise zuzulassen. Zum Beispiel können Sie Cookies von Drittanbietern blockieren, aber alle anderen Cookies zulassen.
            </p>
            <p className="text-base text-[#042A60]/80 leading-relaxed">
              Wenn Sie feststellen möchten, welche Cookies in Ihrem Browser gespeichert wurden, wenn Sie Cookie-Einstellungen ändern oder löschen wollen, können Sie dies in Ihren Browser-Einstellungen finden.
            </p>
          </div>

          {/* Speicherung persönlicher Daten */}
          <div>
            <h2 className="text-2xl lg:text-3xl text-[#042A60] mb-6 font-light">
              Speicherung persönlicher Daten
            </h2>
            <p className="text-base text-[#042A60]/80 leading-relaxed mb-4">
              Persönliche Daten, die Sie uns auf dieser Website elektronisch übermitteln, wie zum Beispiel Name, E-Mail-Adresse, Adresse oder andere persönlichen Angaben im Rahmen der Übermittlung eines Formulars oder Kommentaren im Blog, werden von uns gemeinsam mit dem Zeitpunkt und der IP-Adresse nur zum jeweils angegebenen Zweck verwendet, sicher verwahrt und nicht an Dritte weitergegeben.
            </p>
            <p className="text-base text-[#042A60]/80 leading-relaxed mb-4">
              Wir nutzen Ihre persönlichen Daten somit nur für die Kommunikation mit jenen Besuchern, die Kontakt ausdrücklich wünschen und für die Abwicklung der auf dieser Webseite angebotenen Dienstleistungen und Produkte. Wir geben Ihre persönlichen Daten ohne Zustimmung nicht weiter, können jedoch nicht ausschließen, dass diese Daten beim Vorliegen von rechtswidrigem Verhalten eingesehen werden.
            </p>
            <p className="text-base text-[#042A60]/80 leading-relaxed">
              Wenn Sie uns persönliche Daten per E-Mail schicken – somit abseits dieser Webseite – können wir keine sichere Übertragung und den Schutz Ihrer Daten garantieren. Wir empfehlen Ihnen, vertrauliche Daten niemals unverschlüsselt per E-Mail zu übermitteln.
            </p>
          </div>

          {/* Rechte laut DSGVO */}
          <div>
            <h2 className="text-2xl lg:text-3xl text-[#042A60] mb-6 font-light">
              Ihre Rechte laut der Datenschutzgrundverordnung (DSGVO)
            </h2>
            <p className="text-base text-[#042A60]/80 leading-relaxed mb-4">
              Ihnen stehen laut den Bestimmungen der DSGVO und des österreichischen Datenschutzgesetzes (DSG) grundsätzlich die folgende Rechte zu:
            </p>
            <ul className="list-disc list-inside text-base text-[#042A60]/80 leading-relaxed space-y-2 ml-4">
              <li>Recht auf Berichtigung (Artikel 16 DSGVO)</li>
              <li>Recht auf Löschung („Recht auf Vergessenwerden") (Artikel 17 DSGVO)</li>
              <li>Recht auf Einschränkung der Verarbeitung (Artikel 18 DSGVO)</li>
              <li>Recht auf Benachrichtigung – Mitteilungspflicht im Zusammenhang mit der Berichtigung oder Löschung personenbezogener Daten oder der Einschränkung der Verarbeitung (Artikel 19 DSGVO)</li>
              <li>Recht auf Datenübertragbarkeit (Artikel 20 DSGVO)</li>
              <li>Widerspruchsrecht (Artikel 21 DSGVO)</li>
              <li>Recht, nicht einer ausschließlich auf einer automatisierten Verarbeitung — einschließlich Profiling — beruhenden Entscheidung unterworfen zu werden (Artikel 22 DSGVO)</li>
            </ul>
            <p className="text-base text-[#042A60]/80 leading-relaxed mt-4">
              Wenn Sie glauben, dass die Verarbeitung Ihrer Daten gegen das Datenschutzrecht verstößt oder Ihre datenschutzrechtlichen Ansprüche sonst in einer Weise verletzt worden sind, können Sie sich bei der Aufsichtsbehörde beschweren. Diese ist für Österreich die Datenschutzbehörde, deren Webseite Sie unter <a href="https://www.dsb.gv.at/" target="_blank" rel="noopener noreferrer" className="text-[#0A6AF0] hover:underline">https://www.dsb.gv.at/</a> finden.
            </p>
          </div>

          {/* Kontaktformular */}
          <div>
            <h2 className="text-2xl lg:text-3xl text-[#042A60] mb-6 font-light">
              Auswertung des Besucherverhaltens
            </h2>
            <p className="text-base text-[#042A60]/80 leading-relaxed mb-4">
              In der folgenden Datenschutzerklärung informieren wir Sie darüber, ob und wie wir Daten Ihres Besuchs dieser Website auswerten. Die Auswertung der gesammelten Daten erfolgt in der Regel anonym und wir können von Ihrem Verhalten auf dieser Website nicht auf Ihre Person schließen.
            </p>
            <p className="text-base text-[#042A60]/80 leading-relaxed">
              Mehr über Möglichkeiten dieser Auswertung der Besuchsdaten zu widersprechen erfahren Sie in der folgenden Datenschutzerklärung.
            </p>
          </div>

          {/* TLS Verschlüsselung */}
          <div>
            <h2 className="text-2xl lg:text-3xl text-[#042A60] mb-6 font-light">
              TLS-Verschlüsselung mit https
            </h2>
            <p className="text-base text-[#042A60]/80 leading-relaxed">
              Wir verwenden https um Daten abhörsicher im Internet zu übertragen. Durch den Einsatz von TLS (Transport Layer Security), einem Verschlüsselungsprotokoll zur sicheren Datenübertragung im Internet können wir den Schutz vertraulicher Daten sicherstellen. Sie erkennen die Benutzung dieser Absicherung der Datenübertragung am kleinen Schlosssymbol links oben im Browser und der Verwendung des Schemas https (anstatt http) als Teil unserer Internetadresse.
            </p>
          </div>

          {/* Kontakt */}
          <div>
            <h2 className="text-2xl lg:text-3xl text-[#042A60] mb-6 font-light">
              Kontakt
            </h2>
            <p className="text-base text-[#042A60]/80 leading-relaxed mb-4">
              Wenn Sie Fragen zum Datenschutz haben, schreiben Sie uns bitte eine E-Mail oder wenden Sie sich direkt an die für den Datenschutz verantwortliche Person in unserer Organisation:
            </p>
            <div className="bg-[#F5F5F5] p-6">
              <p className="text-base text-[#042A60] font-medium mb-2">klar:ki</p>
              <p className="text-sm text-[#042A60]/80">Götzlingstr. 45f, 4040 Pöstlingberg</p>
              <p className="text-sm text-[#042A60]/80">E-Mail: <a href="mailto:eva@klar-ki.at" className="text-[#0A6AF0] hover:underline">eva@klar-ki.at</a></p>
              <p className="text-sm text-[#042A60]/80">Telefon: <a href="tel:+4369911413141" className="text-[#0A6AF0] hover:underline">+43 69911413141</a></p>
            </div>
          </div>

        </div>
      </section>

      <Footer />
      <BookingModal isOpen={isBookingModalOpen} onClose={closeBookingModal} />
    </div>
  );
}
